// Localstorage
export const LOCALSTORAGE_USER = '_v_w';
export const LOCALSTORAGE_PLAYER = '_sh_p';
export const LOCALSTORAGE_TRACKING = '_sh_p_t';
export const LOCAL_STORAGE_LANGUAGE = '_lng';
export const LOCALSTORAGE_SOURCE = '_i_s';
export const LOCALSTORAGE_PREVIOUS_PATH_BEFORE_TRANSACTION = '_prev_path_b_t';

// Sessionstorage§
export const SESSIONSTORAGE_OS_SUPPORT = '_os_s';

// Cookie
export const COOKIE_VIDEO_SESSION = '_se_';
export const COOKIE_EXPIRES = 3650;
export const COOKIE_TOKEN = 'token';

// Refresh programs interval
export const REFRESH_PROGRAMS_INTERVAL = 300000;

// Update live program interval
export const UPDATE_LIVE_PROGRAM_INTERVAL = 60000;

// Browser wake up interval
export const BROWSER_WAKE_UP_INTERVAL = 6000;

// Refetch transaction status timeout
export const RECHECK_TRANSACTION_INTERVAL = 5000;

// Refrest subscriber's payment method
export const RECHECK_SUBSCRIBER_PAYMENT_METHOD = 3000;

// Refresh coutry lock check based on IP address
export const KEEP_GEOLOCK_STALE_TIME = 3 * 60 * 1000;
export const KEEP_GEOLOCK_CACHE_TIME = 10 * 60 * 1000;

// Refetch user's verification status
export const REFETCH_USER_DOCUMENT_INTERVAL = 3 * 60 * 1000;
export const REFERCH_USER_VERIFICATION = 3 * 60 * 1000;

// Login
export const AUTHENTICATION_REQUIRED = 'AUTHENTICATION_REQUIRED';
export const DEVICES_LIMIT_EXCEEDED =
	'SUBSCRIBER_ASSIGNED_DEVICES_LIMIT_EXCEEDED';
export const DEVICE_NOT_EXISTS = 'DEVICE_NOT_EXISTS';

export const NO_PROGRAM = 'NO_PROGRAM';

export const CHANNEL_OFFSET_LIMIT = 'offset=0&limit=300';
export const OPERATOR_TYPES = {
	VECTRA: 'vectra'
};

// SectionsGroup names
export const SECTIONS = {
	MAIN_WEB: 'MAIN_WEB',
	VOD_WEB: 'VOD_WEB',
	SERIES_WEB: 'SERIES_WEB',
	KIDS_WEB: 'KIDS_WEB',
	START_WEB: 'START_WEB'
};

// Home
export const SECTIONS_TYPES = {
	LIVE_NOW: 'live_epg',
	BANNER: 'banner',
	VIRTUAL: 'virtual',
	CAROUSEL: 'carousel',
	PROMOTED: 'promoted',
	NORMAL: 'normal'
};

export const MOBILE_SECTIONS = [
	SECTIONS_TYPES.BANNER,
	SECTIONS_TYPES.VIRTUAL,
	SECTIONS_TYPES.CAROUSEL,
	SECTIONS_TYPES.PROMOTED,
	SECTIONS_TYPES.NORMAL
];

export const DESKTOP_SECTIONS = [
	SECTIONS_TYPES.LIVE_NOW,
	SECTIONS_TYPES.BANNER,
	SECTIONS_TYPES.VIRTUAL,
	SECTIONS_TYPES.CAROUSEL,
	SECTIONS_TYPES.PROMOTED,
	SECTIONS_TYPES.NORMAL
];

export const SECTIONS_DATA_ATTR = {
	ID: 'data-section_id',
	LABEL: 'data-section_label',
	TYPE: 'data-section_type'
};

export const VIRTUAL_SECTIONS_TYPES = {
	FAVOURITE_CHANNELS: 'favourite_channels',
	FAVOURITE_MOVIES: 'favourite_movies',
	FAVOURITE_SERIES: 'favourite_series'
};

// VOD
export const VOD_SECTIONS_TYPES = {
	WEB_MOVIES_CONTINUE_WATCHING: 'web_filmy_kontynuujoglądanie'
};

export const VOD_PARAMS = {
	genre: 'gatunek',
	subtype: 'typ',
	order: 'kolejnosc',
	orderDir: 'sortowanie'
};

// EPG
export const EPG_SELECTORS = {
	EPG_CLASS: 'epg'
};

// Player Types
export const PLAYER_TYPES = {
	CATCHUP: 'CATCHUP',
	LIVE: 'LIVE'
};

export const PLAYER_VOD_LIVE_DELAY = 40;

// Search
export const SEARCH_TYPES = {
	program: 'Program TV',
	channel: 'Kanał',
	vod: 'Film',
	series: 'Serial',
	season: 'Sezon',
	episode: 'Odcinek',
	packet: 'Pakiet',
	provision: 'Pakiet',
	collection: 'Kolekcja',
	main: 'Pakiet'
};

// Mobile search maximal items to show
export const MOBILE_MAX_SEARCH_COUNT = 3;

// Program details
export const PROGRAM_RECOMMENDATIONS = {
	MAX_RESULTS: 8
};

// Player selectors
export const PLAYER_SELECTORS = {
	PLAYER: 'player',
	DETAILS: 'player_details',
	VOD: 'player_vod',
	ATDS_PLAYER_CONTAINER_CLASS: 'atdsplayer-container',
	ATDS_PLAYER_HIDE_CURSOR_CLASS: 'hide-cursor',
	SHAKA_CONTROLS_CONTAINER_CLASS: 'shaka-controls-container'
};

export const PRODUCT_TYPES = ['program', 'vod', 'episode'];

export const VOD_PERMITTED_SECTION_LABELS = [
	'virtual',
	'carousel',
	'normal',
	'promoted',
	'banner',
	'live_epg'
];

// url platforms
export const PLATFORM_BROWSER = 'platform=BROWSER';

// core paths as stings
export const ROUTES_CORE_PATHS = {
	HOME: 'strona-glowna',
	WATCH: 'ogladaj',
	RECORDINGS: 'nagrania',
	PACKETS: 'pakiety',
	PAYMENTS: 'historia-platnosci',
	FAVOURITES: 'ulubione',
	REGULATION: 'regulamin',
	CHANNELS: 'kanaly',
	PROGRAM_DETAILS: 'szczegoly-programu',
	SEARCH: 'szukaj',
	REGISTER: 'rejestracja',
	LOGIN: 'logowanie',
	TRANSACTION: 'transakcja',
	USER: 'uzytkownik',
	TV: 'tv',
	PASSWORD_RESET: 'reset-hasla',
	TELEVISION: 'telewizja',
	INTRODUCE_TV_SMART: 'poznaj-tv-smart',
	INTRODUCE_DECODER: 'poznaj-dekoder-tv-smart',
	CONFIGURATOR: 'konfigurator',
	EMAIL_CONFIRMATION: 'potwierdzenie-email'
};

// OS NOT SUPPORTED
export const OS_NOT_SUPPORTED = 'OS_NOT_SUPPORTED';

export const SUPPORTED_OS = ['windows', 'mac os', 'ios', 'android'];

// Product image types
export const PRODUCT_IMAGES_TYPES = {
	COVER: 'cover',
	POSTER: 'poster',
	LOGO: 'logo',
	LOGO_INVERTED: 'logo_inverted',
	COVER_LARGE: 'cover_large',
	COVER_SMALL: 'cover_small',
	TITLE: 'title'
};

// query order translation to filter category items
export const QUERY_ORDER = {
	created_at: 'data_dodania',
	data_dodania: 'created_at',
	year: 'rok_produkcji',
	rok_produkcji: 'year',
	title_org: 'tytul_oryginalny',
	tytul_oryginalny: 'title_org',
	title: 'tytul',
	tytul: 'title'
};

// query order dir translation to filter category items
export const QUERY_ORDER_DIR = {
	asc: 'rosnaco',
	rosnaco: 'asc',
	desc: 'malejaco',
	malejaco: 'desc'
};

// query subtypes translation to filter category items
export const QUERY_SUBTYPES = {
	vod: 'vod',
	series: 'seriale',
	seriale: 'series'
};

// HOME PAGE LABEL
export const HOME_LABEL = 'START_WEB';

// TELEVISION PAGE LABEL
export const TELEVISION_LABEL = 'MAIN_WEB';

// react app projects
export const APP_PROJECT_TYPES = {
	TV_SMART: 'TV_SMART',
	TVO: 'TVO',
	TV_ONLINE: 'TV_ONLINE'
};

// request url system types
export const SYSTEM_TYPES = {
	OTT: 'ott',
	TVONLINE: 'tvonline',
	PURE_OTT: 'pureott'
};

// base links to apps
export const BASE_APPS_URLS = {
	ANDROID_BASE_URL: 'https://play.google.com/store/apps/details?id=',
	APPLE_BASE_URL: 'https://apps.apple.com/pl/app/'
};

// android apps ids
export const ANDROID_APPS_IDS = {
	ANDROID_TV_SMART_ID: 'pl.vectra.ott.android',
	ANDROID_TV_ONLINE_ID: 'pl.tvsmart.app'
};

// apple apps ids
export const APPLE_APPS_IDS = {
	APPLE_TV_SMART_ID: '/vectra-tvonline/id1531305371',
	APPLE_TV_ONLINE_ID: 'tv-smart-go/id1592090029'
};

// Vectra external links
export const VECTRA_EXTERNAL_LINKS = {
	ABOUT_US: 'https://www.vectra.pl/o-nas',
	CONTACT: 'https://www.vectra.pl/kontakt#support',
	FACEBOOK_GROUP: 'https://www.facebook.com/groups/158846811252530/',
	TV_SMART_FAQ: 'https://www.vectra.pl/pomoc/pomoc-techniczna#tv-smart',
	TV_ONLINE_FAQ: 'https://www.vectra.pl/pomoc/pomoc-techniczna#tv-online',
	DECODER_MAXELECTRO:
		'https://maxelektro.pl/sklep/karta-produktu/dekoder-tv-smart-dv8519-pilot,175477.html'
};

// meta tags login page links
export const META_LOGIN_LINKS = {
	TV_ONLINE_LOGIN: 'https://tvonline.vectra.pl/logowanie',
	TV_SMART_LOGIN: 'https://tvsmart.vectra.pl/logowanie'
};

//-------------- MOVIE PREVIEW CONSTANTS ---------------
// preview stripe url
export const STRIPES_URL =
	'https://r.e.blueonline.tv/s/tvsmart/assets/prod/vod';

// numbers of frame in single stripe
export const FRAMES_PER_STRIPE = 32;
// time for single fame
export const TIME_PER_FRAME = 30;

// tracking interval time
export const TRACKING_INTERVAL_TIME = 30000;

// tracking events
export const TRACKING_EVENTS = {
	PLAYING: 'PLAYING',
	BUFFERING: 'BUFFERING',
	PAUSED: 'PAUSED',
	SEEKING: 'SEEKING',
	TRACK_CHANGED: 'TRACK_CHANGED',
	COMPLETE: 'COMPLETE',
	STOPPED: 'STOPPED',
	CLOSED: 'CLOSED',
	ERROR: 'ERROR'
};

// purchase query string values - from blue media url
export const PURCHASE_QUERY_STRING_PARAMS = {
	ORDER_ID: 'OrderID',
	STATUS: 'Status'
};

// status types (mainly used for tracking request status in Redux)
export const STATUS_TYPES = {
	idle: 'idle',
	loading: 'loading',
	success: 'success',
	error: 'error',
	pending: 'pending'
};

// status types for transacion status (response from bluemedia)
export const TRANSACTION_STATUS_TYPES = {
	init: 'init',
	pending: 'pending',
	succeed: 'succeed',
	failed: 'failed' // - also when user cancels transaction
};

export const STATUS_FROM_URL_FAILED = '-1';

export const CONFIRMATION_STATUS_WAITING = 'waiting';

// data of login tabs
export const LOGIN_TABS_NAMES = {
	pureott: 'pureott',
	vectra: 'vectra'
};

// data of register tabs
export const REGISTER_TABS_NAMES = {
	pureott: 'pureott',
	vectra: 'vectra'
};

// login system types
export const LOGIN_SYSTEM_TYPES = { pureott: 'pureott', vectra: 'vectra' };

// portal languages
export const LANGUAGES_TYPES = {
	ENG: 'eng',
	PL: 'pl',
	UK: 'uk'
};

export const THEME_NAMES = {
	PURE_OTT: 'PURE_OTT',
	OTT: 'OTT',
	TV_ONLINE: 'TV_ONLINE'
};
// CSS Positions
export const CSS_POSITIONS = {
	ABSOLUTE: 'absolute',
	STATIC: 'static',
	RELATIVE: 'relative',
	FIXED: 'fixed',
	STICKY: 'sticky'
};

export const VECTRA_LOGIN_BACKGROUND =
	'https://r.e.blueonline.tv/scale/tvsmart/static/www/start.jpg?dstw=3061&dsth=1680&quality=80';

// POSTAL CODES
export const POSTAL_CODES_REGEX = {
	POLAND: /^([0-9]{2})(-[0-9]{3})?$/i
};

// INVOICE
export const INVOICE_TYPES = {
	BUSINESS: 'business',
	INDIVIDUAL: 'individual'
};

// Images type
export const IMAGES_TYPES = {
	POSTER: 'poster',
	LOGO: 'logo'
};

export const PRODUCTS_TYPES = {
	ALL: 'all',
	VOD: 'vod',
	AUDIO: 'audio',
	ARTICLE: 'article',
	LIVE_EVENT: 'live_event',
	SERIES: 'series',
	COLLECTION: 'collection',
	MAIN: 'main',
	PACKET: 'packet',
	SEASON: 'season',
	EPISODE: 'episode',
	PROVISION: 'provision',
	CHANNEL: 'channel',
	BANNER: 'banner',
	PASS: 'pass',
	WALLET: 'wallet',
	VOUCHER_TEMPLATE: 'voucher_template',
	MOVIE: 'movie',
	PROGRAM: 'program'
};

export const SIDE = {
	RIGHT: 'right',
	LEFT: 'left'
};

export const TRACKING_TYPES = {
	GA: 'GOOGLE_ANALITICS',
	GTM: 'GOOGLE_TAG_MANAGER',
	PIXEL: 'FACEBOOK_PIXEL'
};

export const VERIFICATION = {
	VERIFIED: 'verified',
	IN_PROGRESS: 'being_verified',
	UNVERIFIED: 'unverified'
};

export const NAV_SYSTEM_TYPES = {
	RETAIL: 'retail',
	VECTRA: 'vectra'
};

export const CONFIGURATOR_STATUS = {
	UNACTIVATED: 'unactivated',
	PENDING: 'pending',
	ACTIVE: 'active',
	EXPIRED: 'expired',
	CANCELED: 'canceled',
	DELETED: 'deleted',
	EXPIRING: 'expiring'
};

export const PACKET_STATUS = {
	UNACTIVATED: 'unactivated',
	PENDING: 'pending',
	ACTIVE: 'active',
	EXPIRED: 'expired',
	CANCELED: 'canceled',
	DELETED: 'deleted',
	EXPIRING: 'expiring'
};

export const CONFIGURATOR_PRICES = {
	NEW_SUBSCRIPTION: 'new_subscription',
	UPGRADE_SUBSCRIPTION: 'upgrade_subscription',
	DOWNGRADE_SUBSCRIPTION: 'downgrade_subscription',
	ADD_ADDITIONAL_PRODUCTS: 'add_additional_products'
};

export const GEO_LOCK_MODAL_TYPES = {
	PURCHASE: 'PURCHASE',
	WATCH: 'WATCH'
};

export const BLIK_DIGIT_REGEX = /^[0-9]+$/;
export const BLIK_REQUIRED_LENGTH = 6;

export const LOGIN_WITH_CODE_CODE_LENGTH = 6;

export const CONFIGURATOR_URL = '/step-';

// Contact form
export const FILE_SIZES = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
export const MIME_TYPES = {
	JPEG: 'image/jpeg',
	PNG: 'image/png',
	PDF: 'application/pdf',
	DOC: 'application/msword',
	DOCX:
		'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
	EXCEL: 'application/vnd.ms-excel',
	SPREAD_SHEET:
		'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	TXT: 'text/plain'
};

export const DRAG_AND_DROP_CONTACT_FORM_CONFIG = {
	allowedMimes: [
		MIME_TYPES.JPEG,
		MIME_TYPES.PNG,
		MIME_TYPES.PDF,
		MIME_TYPES.DOC,
		MIME_TYPES.DOCX,
		MIME_TYPES.EXCEL,
		MIME_TYPES.SPREAD_SHEET,
		MIME_TYPES.TXT
	],
	allowMultiple: true,
	maxFileCount: 4,
	maxTotalSize: 4 * 5 * 1024 * 1000, // 4 * 5MB
	maxSizePerFile: 5 * 1024 * 1000, // 5MB
	subtitle: '(Dozwolone formaty: PDF, PNG, JPG, DOC - maksymalny rozmiar 5 MB)'
};

export const excludedPaths = ['/transakcja/return'];

// Documents that needs to be highlighted
export const HIGHLIGHTED_DOCUMENTS_NAMES = [
	'WYKAZ PROGRAMO\u0301W TV SMART - EPG.pdf'
];

// Slider drag minimum client coordinates change
export const SLIDER_DRAG_MINIMUM_POSITION_CHANGE = 5;

export const EVENTS_NAMES = {
	PLAY: 'play',
	PAUSE: 'pause',
	ERROR: 'error',
	WAITING: 'waiting',
	PLAYING: 'playing',
	LOADEDDATA: 'loadeddata',
	FULLSCREENCHANGE: 'fullscreenchange',
	ENDED: 'ended',
	TIMEUPDATE: 'timeupdate',
	BUFFERING: 'buffering',
	ADAPTATION: 'adaptation',
	VARIANTCHANGED: 'variantchanged',
	SCROLL: 'scroll',
	RESIZE: 'resize',
	MOUSE_ENTER: 'mouseenter',
	MOUSE_LEAVE: 'mouseleave'
};

export const SECTIONS_CACHE_TIME = 15 * 60 * 1000; // 15 minutes

export const PACKETS_CACHE_TIME = 10 * 60 * 1000; // 10 minutes

export const SUBSCRIPTION_CACHE_TIME = 10 * 60 * 1000; // 10 minutes

export const CONFIGURATOR_SETTINGS_CACHE = 1 * 60 * 60 * 1000; // 1 hour

export const CONFIGURATOR_PRICE_CACHE = 10 * 60 * 1000; // 10 minutes

export const CONFIGURATOR_DOCUMENTS_CACHE = 30 * 60 * 1000; // 30 minutes

export const PACKET_TYPES = {
	MAIN: 'main',
	PREMIUM: 'premium'
};

export const CONFIGURATOR_MODALS = {
	AUTH: 'configurator_auth',
	PENDING_CHANGE: 'configurator_pending_change',
	PENDING_PAYMENT: 'configurator_pending_payment',
	DECODER: 'configurator_decoder',
	CLOSE: 'configurator_close',
	FAILED_PAYMENT: 'configurator_failed_payment',
	WAITING_PAYMENT: 'configurator_payment_waiting',
	EMAIL: 'configurator_email',
	CHANNELS: 'configurator_channels'
};
